import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Nav.css";

export const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const navRef = useRef(null);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);

  const location = useLocation();
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const isActive = (path) => location.pathname === path;
 useEffect(() => {
  const handleClickOutside = (event) => {
    if (menuOpen && navRef.current && !navRef.current.contains(event.target)) {
      setMenuOpen(false); 
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [menuOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  
 useEffect(() => {
  setMenuOpen(false);
}, [location.pathname]);
  return (
    <div 
    ref={navRef}
    className={`nav-container ${showNavbar ? "show" : "hide"} ${menuOpen ? "open" : ""}`}>
      <h1 className="nav-title">
        ADHIE ANNAN <br />
        <span style={{ letterSpacing: "10px" }}>TEMPLE</span>
      </h1>

      <ul className="nav-links desktop">
        <li className={isActive("/") ? "active" : ""}><Link to="/">Home</Link></li>
        <li className={isActive("/gallery") ? "active" : ""}><Link to="/gallery">Gallery</Link></li>
        <li className={isActive("/about") ? "active" : ""}><Link to="/about">About</Link></li>
        <li className={isActive("/deities") ? "active" : ""}><Link to="/deities">Deities</Link></li>
        <li className={isActive("/pooja") ? "active" : ""}><Link to="/pooja">Pooja</Link></li>
        <li className={isActive("/transport") ? "active" : ""}><Link to="/transport">Transport</Link></li>
        <li className={isActive("/support") ? "active" : ""}><Link to="/support">Support</Link></li>
      </ul>

      <ul className={`nav-links mobile ${menuOpen ? "open" : "close"}`}>
        <li className={isActive("/") ? "active" : ""}><Link to="/">Home</Link></li>
        <li className={isActive("/gallery") ? "active" : ""}><Link to="/gallery">Gallery</Link></li>
        <li className={isActive("/about") ? "active" : ""}><Link to="/about">About</Link></li>
        <li className={isActive("/deities") ? "active" : ""}><Link to="/deities">Deities</Link></li>
        <li className={isActive("/pooja") ? "active" : ""}><Link to="/pooja">Pooja</Link></li>
        <li className={isActive("/transport") ? "active" : ""}><Link to="/transport">Transport</Link></li>
        <li className={isActive("/support") ? "active" : ""}><Link to="/support">Support</Link></li>
       </ul>
      <div className="burger-icon" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </div>
  );
};
